'use strict';

/*global app*/
/*global services*/

function ReleaseNoteService() {
  this.modal = null;

  this.init();
}

ReleaseNoteService.prototype = $.extend({}, {
  constructor: 'ReleaseNoteService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.release-note__create', function () {
      _this.create($(this).data('article_id'));

      return false;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  doCreate: function doCreate(articleId, quantity) {
    var _this = this;

    var data = {
      WorkplaceRID: app.param('workplace_rid'),
      ArticleId: articleId,
      Quantity: quantity,
    };

    services.get('user-additional-login').isUserLogined(function () {
      app.getFormation('release_note:create', data, function (res) {
        if (res.msg === 'SUCCESS') {
          app.viewSuccessMessage();

          $('body').trigger('release-note-created');
        } else if (res.msg === 'NOT_VALID') {
          app.viewWarningMessage();
        } else {
          app.viewErrorMessage(res.error);
        }
      });
    });

    return _this;
  },

  create: function create(articleId) {
    var _this = this;

    services.get('article').get(articleId, function (data) {
      var options = {
        content: app.t('release_note.help').replace('{ArticleName}', data.Name),
        asHtml: true,
        suffix: data.AltUnit
      };

      app.getValue(options, function (value) {
        if (value !== 0) {
          _this.doCreate(articleId, value);
        }
      });
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.modal = services.get('modal-release-note');

    _this.registerCallbacks();

    return _this;
  }
});
